<template>
  <v-app id="petra">
    <v-main>
      <v-container fluid>
        <v-row>
          <v-col cols="5">
            <p>Monthly overview of payments</p>
          </v-col>
        </v-row>

        <v-row>    
          <v-col cols="1">
            <v-select 
              v-model="selMonth" 
              :items="monthSelections" 
              item-value="ode" 
              item-text="description" 
              label="Period"
              @change="excelDownload = ''; pdfDownload = ''">
            </v-select>

          </v-col>
        </v-row>

        <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0 mb-2" small :disabled="selMonth === ''" @click="petraMakeOverview">Make overview</v-btn>
          </v-col> 
        </v-row>
      </v-container>
    </v-main>
    <navBar title="Ares - Excel Exports" :home="true" type="excel" />
   </v-app>
</template>

<script>
  import navBar from "@/components/ui/navbars/navbar.vue";
    
  export default {
    components: {
      navBar,
    },
    data() {
      return {
        results: false,
        selMonth: '',
        period: '',
        monthSelections: [],
      }
    },
    mounted() {
      this.petraGetMonths();
    },
    methods: {
      petraGetMonths() {
        this.$axios.post("ares/json/ares/task/excel/tmp/petraGetMonths.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "petraGetMonths"
          },
          petraGetMonths: {}
        }).then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
             this.monthSelections = res.data.petraGetMonths;
          }
        })
      },
      petraMakeOverview() {
        this.period = this.selMonth;
        this.selMonth = "";
        this.$axios.post("ares/json/ares/task/excel/tmp/petraMakeOverview.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "petraMakeOverview"
          },
          petraMakeOverview: {
            period: this.period
          }
        }).then(res => {
          if (res.data.error) {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.error,
              color: "error",
            });
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.petraMakeOverview.text,
              color: res.data.petraMakeOverview.color,
            });
          }
        })
      },
    }
  };
</script> 
